import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type ISkeletonProps from "./type";
import stylesheet, {
    getSkeletonMeasures,
    useStyles
} from "./stylesheet";
import SkeletonGroup from "./components/group";
import SkeletonShape from "./components/shape";
import {
    NCoreUIKitTheme
} from "../../core/hooks";

const Skeleton: FC<ISkeletonProps> = ({
    typography: typographyVariant = "bodyMediumSize",
    animation = "pulse",
    variant = "block",
    aspectRatio,
    customTheme,
    lines = 1,
    height,
    radius,
    style,
    width,
    size,
    ...props
}) => {
    const {
        controlHeights,
        shapeConfigs,
        avatarSizes,
        typography,
        iconSizes,
        radiuses
    } = NCoreUIKitTheme.useContext(customTheme);

    const currentMeasures = getSkeletonMeasures({
        typographyVariant,
        avatarSizes,
        typography,
        iconSizes,
        radiuses,
        variant,
        radius,
        size
    });

    const {
        container: containerDynamicStyle,
        shape: shapeDynamicStyle,
        line: lineDynamicStyle
    } = useStyles({
        currentMeasures,
        controlHeights,
        shapeConfigs,
        aspectRatio,
        variant,
        height,
        width
    });

    if(variant === "text") {
        const lineCount = Math.max(1, Math.floor(lines));

        return <View
            {...props}
            style={[
                style,
                stylesheet.container,
                containerDynamicStyle
            ]}
            aria-hidden={true}
        >
            {
                Array.from({
                    length: lineCount
                }, (_, index) => <SkeletonShape
                    style={[
                        stylesheet.line,
                        index === lineCount - 1 && lineCount > 1 ? stylesheet.lastLine : undefined,
                        lineDynamicStyle
                    ]}
                    customTheme={customTheme}
                    animation={animation}
                    key={index}
                />)
            }
        </View>;
    }

    return <SkeletonShape
        {...props}
        customTheme={customTheme}
        style={[
            style,
            stylesheet.shape,
            shapeDynamicStyle
        ]}
        animation={animation}
        aria-hidden={true}
    />;
};
export default Object.assign(Skeleton, {
    Group: SkeletonGroup
});
